/**
 * Prefurn Product Description Enhancer
 * - Converts FAQ H3+P sections to native <details>/<summary> accordions
 * - Works automatically on all product pages without editing product descriptions
 */
(function () {
  'use strict';

  function initFaqAccordion() {
    // Target the product description area - try common Shopify theme selectors
    var descriptions = document.querySelectorAll(
      '.product-single--detail .rte, .product__description .rte, .product-description, [data-product-description], .product-information .rte'
    );

    // Fallback: any .rte element inside the main product container
    if (descriptions.length === 0) {
      var productContainer = document.querySelector('.thb-product-detail, .product, [data-product]');
      if (productContainer) {
        descriptions = productContainer.querySelectorAll('.rte');
      }
    }

    descriptions.forEach(function (desc) {
      // Find 'Veelgestelde vragen' H2
      var allH2 = desc.querySelectorAll('h2');
      var faqHeading = null;
      for (var i = 0; i < allH2.length; i++) {
        if (/veelgestelde|faq/i.test(allH2[i].textContent)) {
          faqHeading = allH2[i];
          break;
        }
      }
      if (!faqHeading) return;

      var faqContainer = document.createElement('div');
      faqContainer.className = 'product-faq';

      var current = faqHeading.nextElementSibling;
      var toRemove = [];

      while (current && current.tagName !== 'H2') {
        if (current.tagName === 'H3') {
          var questionText = current.textContent.trim();
          var details = document.createElement('details');
          var summary = document.createElement('summary');
          summary.textContent = questionText;
          details.appendChild(summary);

          var answerDiv = document.createElement('div');
          answerDiv.className = 'faq-answer';

          var next = current.nextElementSibling;
          while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
            answerDiv.appendChild(next.cloneNode(true));
            toRemove.push(next);
            next = next.nextElementSibling;
          }

          details.appendChild(answerDiv);
          faqContainer.appendChild(details);
          toRemove.push(current);
          current = next;
        } else {
          current = current.nextElementSibling;
        }
      }

      if (faqContainer.children.length > 0) {
        // Remove originals
        toRemove.forEach(function (el) {
          if (el.parentNode) el.parentNode.removeChild(el);
        });
        // Insert accordion after the FAQ heading
        faqHeading.parentNode.insertBefore(faqContainer, faqHeading.nextSibling);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();
